import { useHoverPopoverClose } from '@app/components/base/HoverPopover';
import { useStreamSelection } from '@app/modules/logger/screens/stream/stores/useStreamSelection';
import { AuditLiveMention, toTimestamp } from '@mi-front/core';
import { Visibility as VisibilityIcon } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';

/**
 * Selects and reveals the detected mention range in the stream.
 */
export function LiveMentionShowButton({ liveMention }: { liveMention: AuditLiveMention }) {
  const { setSelection } = useStreamSelection();
  const closePopover = useHoverPopoverClose();
  const mentionTime = liveMention.customData?.time;

  if (!mentionTime) {
    return null;
  }

  const handleShow = () => {
    setSelection(toTimestamp(mentionTime.start), toTimestamp(mentionTime.end));
    closePopover?.();
  };

  return (
    <Tooltip
      title={
        <FormattedMessage id="logger.liveMentions.showMention" defaultMessage="Mostrar mención" />
      }
      placement="top"
    >
      <IconButton size="small" color="secondary" onClick={handleShow}>
        <VisibilityIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
